import { ThemeOptions } from '@mui/material/styles/createTheme';
import { AlertProps } from '@mui/material/Alert';
import { lighten } from '@mui/system/colorManipulator';

let style = {
  display: 'flex',
  width: '100%',
  minHeight: '1.5rem',
  alignItems: 'top',
  padding: '.75rem',
  lineHeight: '24px',
  fontSize: '1rem',
  borderWidth: '1px',
  borderStyle: 'solid',
  gap: '.5rem',
  '& .MuiAlert-icon': {
    padding: 0,
    marginRight: '.25rem',
  },
  '& .MuiAlert-action': {
    padding: 0,
    margin: 0,
    '& .MuiButtonBase-root': {
      padding: '.125rem',
    },
  },
  '& .MuiAlert-message': {
    width: '100%',
    color: 'text.primary',
    padding: 0,
    fontSize: '1rem',
    lineHeight: '1.5rem',
  },
} as Record<string, any>;


export const MuiAlertStyle = {
  variants: [
    {
      props: { variant: 'text' as const },
      style: {
        ...style,
        padding: 0,
        border: 'none',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        '&& .MuiAlert-icon': {
          margin: 0,
        },
      },
    },
  ],
  styleOverrides: {
    root: ({ theme, ownerState }: { theme: ThemeOptions; ownerState: AlertProps }) => {
      const ownerStateSeverity = ownerState?.severity || 'success';
      const ownerStateVariant = ownerState?.variant || 'outlined';

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const palletColor = theme.palette[ownerStateSeverity];

      if (palletColor && ownerStateVariant === 'text') {
        return {
          ...style,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          color: palletColor?.main ?? 'inherit',
        }
      }
      if (palletColor && ownerStateVariant === 'standard') {
        return {
          ...style,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          backgroundColor: lighten(palletColor?.light ?? palletColor?.main, 0.75),
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          borderColor: palletColor?.dark ?? 'initial',
          '&& .MuiAlert-icon': {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            color: ownerStateSeverity === 'success' ? 'inherit' : palletColor?.main ?? 'inherit',
          },
          '&& .MuiAlert-message': {
            color: theme.palette?.text?.primary ?? '#252A2E',
          },
        }
      }
      return style;
    },
  },
};

declare module '@mui/material/Alert' {
  interface AlertPropsVariantOverrides {
    text: true;
  }
}
